import { kea } from 'kea'
import PropTypes from 'prop-types'

import sceneLogic from '~/scenes/search/logic'

export default kea({
  connect: {
    props: [sceneLogic, ['startMessage']]
  },

  selectors: ({ selectors }) => ({
    howContents: [
      () => [selectors.startMessage],
      ({ howContents }) => {
        if (!howContents) {
          return null
        }

        return typeof howContents === 'object' ? Object.entries(howContents) : []
      },
      PropTypes.oneOfType([
        PropTypes.array, // When Object.entries(howContents) returns an array
        PropTypes.oneOf([null]) // Explicitly handle null as a possible return value
      ])
    ]
  })
})
